import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@sm/wds-react';
import { t, defineMessages } from '@sm/intl';
import { useSurveyTheme, createSurveyStyles } from '@sm/webassets';
import checkDarkMode from '~app/helpers/luminance';
import './action-group.scss';

const DEFAULT_COPY = defineMessages({
  DONE: {
    id: 'ActionGroup.Done',
    defaultMessage: 'Done',
    description: '[Type: Button][Vis.: low] - Done button',
  },
});

const useStyles = createSurveyStyles(theme => {
  return {
    actionGroupButton: {
      color: theme.secondaryAccentColor,
      backgroundColor: theme.primaryAccentColor,
      fontFamily: theme.questionBody.fontFamily,
    },
  };
});

const ActionGroup = ({ qrDoneUrl }) => {
  const theme = useSurveyTheme();
  const { actionGroupButton } = useStyles();
  const backgroundColor = theme.primaryBackgroundColor || '#fff';
  const acBtnColor = checkDarkMode(backgroundColor) ? 'black' : 'primary';

  return (
    <div className="sm-action-group--container">
      <div className="sm-action-group--cta">
        <Button className={actionGroupButton} size="lg" color={acBtnColor} href={qrDoneUrl}>
          {t(DEFAULT_COPY.DONE)}
        </Button>
      </div>
    </div>
  );
};

ActionGroup.propTypes = {
  qrDoneUrl: PropTypes.string.isRequired,
};

export default ActionGroup;
